// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  castToFloat,
  getNestedByString,
} from 'helpers/reduxFormFunctions'

// updatedFieldNames is an array of strings which point
// to a polarizationStateId in formValues.
// This function constructs the DTO to update the specified
// path's individual channel pair polarizationStateId.
const makeAFSPathPolarizationUpdateDTO = (updatedFieldNames, formValues) => (
  updatedFieldNames.reduce((a, d, i) => {
    const polarizationStateId = getNestedByString(formValues, d)

    // takes "path_id_1234.channel_index_2"
    // makes: ["path_id_1234", "channel_index_2"]
    // and assigns variable names in one fell swoop
    const [
      pathName,
      channelIndexName,
    ] = d.split('.')

    // .substring(8) for "path_id_"
    const pathId = castToFloat(pathName.substring(8))

    // .substring(14) for "channel_index_"
    const channelIndex = castToFloat(channelIndexName.substring(14))

    const channelPair = {
      channelIndex,
      polarizationStateId,
    }

    // this reference is used below to update nested value
    // but "a", which holds this element is what is returned by the reducer.
    const pathUpdateDTO = a.find(d => d.pathId === pathId)

    // if we haven't yet created a pathUpdateDTO for this pathId
    // then make one and add it to the list!
    if (pathUpdateDTO === undefined) {
      a.push({
        pathId,
        channelPairs: [channelPair],
      })
    // else we're just gonna add this channel pair update to the existing pathUpdateDTO
    } else {
      pathUpdateDTO.channelPairs.push(channelPair)
    }

    return a
  }, [])
    .map(d => {
      // order the channelPairs array by channelIndex, ascending
      // TODO - can we remove this? Does the API care?
      d.channelPairs.sort((a, b) => a.channelIndex > b.channelIndex ? 1 : -1)
      return d
    })
)

export default makeAFSPathPolarizationUpdateDTO
